<template>
  <LazyIconUnauthorized v-if="code === 401" v-bind="attrs" />
  <LazyIconPermission v-else-if="code === 403" v-bind="attrs" />
  <LazyIconNotFound v-else-if="code === 404" v-bind="attrs" />
  <LazyIconToManyRequestsError v-else-if="code === 429" v-bind="attrs" />
  <LazyIconGeneralError v-else v-bind="attrs" />
</template>
<script setup lang="ts">
const attrs = useAttrs()
defineProps<{ code: number | string }>()
</script>
